import { render, staticRenderFns } from "./wxOrders.vue?vue&type=template&id=3694c829&scoped=true&"
import script from "./wxOrders.vue?vue&type=script&lang=js&"
export * from "./wxOrders.vue?vue&type=script&lang=js&"
import style0 from "./wxOrders.vue?vue&type=style&index=0&id=3694c829&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694c829",
  null
  
)

export default component.exports